import useSalonAcceptanceController from "@jury/api/useSalonAcceptanceController"

export default function useApi(
    id: string | number,
    controller: Jury.Controllers.Salon
): Jury.Models.Salon.Api {
    const salonAcceptanceController = useSalonAcceptanceController(id)
    const acceptances = salonAcceptanceController.index

    return {
        acceptances
    }
}